var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},_vm._l((_vm.moduleData.steps),function(m){return _c('div',{key:m.id,class:[{ complete: m.complete, active: m.number == _vm.step }, m.type]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }